import { useEffect, useState } from 'react'
import { cn } from "@/lib/utils"
import StrategyResultsGraphBalance from './StrategyResultsGraphBalance.jsx'
import StrategyResultsGraphEntries from './StrategyResultsGraphEntries.jsx'
import StrategyResultsGraphProfitLoss from './StrategyResultsGraphProfitLoss.jsx'
import { server } from '../chat/Server.js'
import StrategyBacktestVisual from './StrategyBacktestVisual.jsx'
import { isSymbolVisualSupported } from '../../utils/symbolVisualSupport.js'

export default function StrategyResultsMain({ strId, backtest, playViewActive }) {
    const [viewMain, setViewMain] = useState('balance')
    const [dataGraph, setDataGraph] = useState()
    const [errorGraph, setErrorGraph] = useState()

    const supportsVisualViews = isSymbolVisualSupported(backtest?.inputs?.symbol)

    useEffect(() => {
        if (playViewActive && viewMain !== 'play' && supportsVisualViews) {
            setViewMain('play')
        }
    }, [playViewActive, viewMain, supportsVisualViews])

    useEffect(() => {
        if (backtest.processingStatus !== 'completed') {
            setDataGraph(null)
            return
        }
        server.api('strategy/backtest/results', { strId, backtestId: backtest.backtestId, section: 'summary' }).then(res => {
            setDataGraph(JSON.parse(res))
        }).catch(() => {
            setErrorGraph('Error generating graphs')
        })
    }, [strId, backtest])

    if (backtest.processingStatus === 'error') {
        return null
    }
    const elementErrorGraph = (
        <div className="flex p-4 rounded-md border border-border bg-card h-full justify-center">
            <span className="text-danger text-body">{errorGraph}</span>
        </div>
    )

    if (errorGraph) {
        return elementErrorGraph
    }

    if (!dataGraph) {
        return null
    }

    return (
        <div>
            <div className="flex justify-start flex-wrap gap-2">
                <ViewTab active={viewMain === 'balance'} onClick={() => setViewMain('balance')}>Balance</ViewTab>
                <ViewTab active={viewMain === 'entries'} onClick={() => setViewMain('entries')}>Entries</ViewTab>
                <ViewTab active={viewMain === 'profitLoss'} onClick={() => setViewMain('profitLoss')}>Profit and Loss</ViewTab>
            </div>
            <div className="content rounded-md mt-6 mb-6 bg-card border border-border">
                {viewMain === 'balance' && <StrategyResultsGraphBalance data={dataGraph["balance"]} />}
                {viewMain === 'entries' && <StrategyResultsGraphEntries data={dataGraph} />}
                {viewMain === 'profitLoss' && <StrategyResultsGraphProfitLoss data={dataGraph} />}
                {supportsVisualViews && viewMain === 'play' && <StrategyBacktestVisual strategyId={strId} backtestId={backtest.backtestId} initialMode="play" autoPlay={playViewActive} />}
                {supportsVisualViews && viewMain === 'candle' && <StrategyBacktestVisual strategyId={strId} backtestId={backtest.backtestId} initialMode="normal" />}
            </div>
        </div>
    )
}

function ViewTab({ active, onClick, children }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                "px-3 py-1.5 rounded-md text-label transition-colors cursor-pointer",
                active
                    ? "bg-primary text-primary-foreground"
                    : "border border-border text-foreground hover:bg-hover"
            )}
        >
            {children}
        </button>
    )
}
